import React, { useCallback, useEffect, useRef, useState } from "react";
import Modal from "react-modal";

import TripEventsApi from "../../../../services/resources/TripEventsApi";
import { notify } from "react-notify-toast";
import axios from "axios";

function CapacityOverrideModal({
  onClose,
  campusName,
  chabadHouseName,
  enrollmentId,
  currentCapacityOverride,
  defaultChabadHouseCapacity,
  shliachFirstName,
  shliachLastName,
  shluchaFirstName,
  shluchaLastName,
}) {
  const [capacityOverride, setCapacityOverride] = useState(
    currentCapacityOverride ?? defaultChabadHouseCapacity,
  );
  const [submitting, setSubmitting] = useState(false);

  const capacityOverrideNote =
    !capacityOverride ||
    parseInt(capacityOverride) === defaultChabadHouseCapacity
      ? ""
      : `* You set the capacity ${capacityOverride < defaultChabadHouseCapacity ? "lower" : "higher"} ` +
        `than COCI's default of ${defaultChabadHouseCapacity}`;

  const apiSignalRef = useRef(axios.CancelToken.source());

  useEffect(() => {
    const _apiSignal = apiSignalRef.current;
    return () => _apiSignal.cancel();
  }, []);

  const onSubmit = useCallback(async () => {
    const value =
      !capacityOverride ||
      parseInt(capacityOverride) === defaultChabadHouseCapacity
        ? null
        : parseInt(capacityOverride);

    if (value !== null && (isNaN(value) || value <= 0)) {
      notify.show("Capacity must be a positive number", "error");
      return;
    }

    setSubmitting(true);

    try {
      await TripEventsApi.updateChabadHouseCapacityOverride(
        apiSignalRef.current.token,
        enrollmentId,
        value,
      );

      onClose(true);
      notify.show("Capacity override updated", "success");
    } catch (err) {
      if (!axios.isCancel(err)) {
        notify.show("Error updating capacity override", "error");
      }
    }

    setSubmitting(false);
  }, [capacityOverride, enrollmentId, onClose, defaultChabadHouseCapacity]);

  return (
    <Modal isOpen={true} className="modal-container">
      <div className="modal-card card medium-modal">
        <p className="large-text fw-500 mb-8">Capacity Override</p>
        <div className="mb-16">
          <div className="fw-700">
            {shliachLastName ? `${shliachFirstName} ${shliachLastName}` : ""}
            {shluchaLastName
              ? `${shliachLastName ? " and " : ""}${shluchaFirstName} ${shluchaLastName}`
              : ""}
          </div>
          <div className="fw-500 small-text">
            {chabadHouseName ? `${chabadHouseName} | ` : ""}
            {campusName}
          </div>
        </div>
        <div className="flex flex-align-center mb-16">
          <div className="input-label flex flex-align-start">
            Chabad House capacity
            <span className="tooltip-container">
              <i className="material-icons large-text ml-4">info</i>
              <span className="tooltip">
                Maximum number of students for this Chabad House
              </span>
            </span>
          </div>
          <input
            className="custom-input ml-8"
            min="1"
            onChange={(e) => setCapacityOverride(e.target.value)}
            type="number"
            value={capacityOverride}
          />
        </div>
        <p className="small-text accent-text mb-16">{capacityOverrideNote}</p>
        <div className="flex flex-justify-end mt-24">
          <button
            className="custom-btn btn btn-light uppercase-text mr-16"
            disabled={submitting}
            onClick={() => onClose(false)}
          >
            Cancel
          </button>
          <button
            className="custom-btn btn btn-accent uppercase-text"
            disabled={submitting}
            onClick={onSubmit}
          >
            {submitting ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default CapacityOverrideModal;
